@use '@va/styles/variables.scss';
@use '@va/styles/mixins.scss';

.clear-fix {
  clear: both;
}

.page-footer {
  @media only screen and (min-width: variables.$deviceWidthMD) {
    width: calc(100% - 4.5rem);
    margin-left: 4.5rem;
  }

  & {
    font-size: 0.875rem;
    font-weight: 300;
    background: variables.$white-color;
    color: #000000;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
  }

  .footer-content {
    justify-content: space-between;
    padding: 1.25rem 1.875rem;
    user-select: none;

    @include mixins.screen-up-to-md {
      padding: 1.25rem 0.625rem;
    }
  }

  .footer-links {
    display: block;

    .first-row,
    .second-row {
      display: inline-flex;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      align-content: center;

      .centered-row {
        display: flex;
        margin: auto;
        align-content: center;
        align-items: center;

        @include mixins.screen-up-to-md {
          display: inline-grid;
        }

        @include mixins.screen-up-to-xs {
          display: flex;
          flex-flow: column;
        }

        .links-group {
          display: inline-flex;

          @include mixins.screen-up-to-xs {
            display: flex;
            flex-flow: row wrap;

            .footer-link {
              display: flex;
              flex: 1;
              flex-basis: 100%;
              margin: auto;
              justify-content: center;
            }
          }

          &:last-child {
            @include mixins.screen-down-to-md {
              .footer-link:last-child {
                & > a:after {
                  content: none;
                }
              }
            }
          }

          @include mixins.screen-up-to-md {
            margin: auto;

            .footer-link:last-child {
              & > a {
                &:after {
                  content: none;
                }
              }
            }
          }

          .footer-link {
            position: relative;
            margin: 0 0.875rem;

            .highlighted-word {
              font-weight: normal;
            }

            @include mixins.screen-up-to-md() {
              &:first-child {
                margin: 0 0.875rem 0 0;
              }

              &:last-child {
                margin: 0 0 0 0.875rem;

                &:after {
                  content: none;
                }
              }
            }

            @include mixins.screen-up-to-xs {
              &:nth-child(n) {
                margin: unset;
              }
            }
          }

          &:first-child {
            .footer-link:last-child {
              margin: 0 0.875rem 0 0.875rem;
            }
          }
        }
      }

      .footer-link > a:after,
      .copyright-text:after {
        content: '\b7';
        font-size: 0.9375rem;
        align-items: center;
        align-content: center;
        color: #444444;

        @include mixins.screen-up-to-xs {
          content: none;
        }
      }

      @include mixins.screen-sm {
        .footer-link:last-child > a:after,
        .copyright-text:after {
          content: none;
        }
      }

      .footer-copyright {
        @include mixins.screen-up-to-md {
          margin: 1.875rem auto;
        }

        .copyright-text {
          position: relative;
          margin-right: 0.875rem;

          @include mixins.screen-up-to-md {
            &:after {
              content: none;
            }
          }

          @include mixins.screen-up-to-xs {
            margin: unset;
          }
        }
      }

      .footer-link > a,
      .copyright-text {
        &:after {
          position: absolute;
          display: inline-block;
          right: -0.9375rem;
          text-decoration: none;
          font-weight: bold;
        }
      }
    }

    .category-title {
      font-size: 0.9375rem;
      font-weight: 400;
      padding-bottom: 0.625rem;
    }

    .footer-link {
      a {
        padding: 0.125rem 0;
        font-size: 0.8125rem;
        text-decoration: none;
        color: var(--color-primary);
        cursor: pointer;

        &:hover {
          text-decoration: underline;

          .a:hover:after {
            text-decoration: none;
          }
        }
      }
    }
  }

  .footer-icons-container {
    display: flex;
    flex-direction: row;

    .footer-icons {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: auto;

      .footer-icon {
        display: flex;
        margin-right: 2.5rem;
        margin-top: 1.875rem;
        width: 1.875rem;
        height: 1.875rem;
        justify-content: center;

        svg {
          width: 1.875rem;
          height: 1.875rem;
        }

        @include mixins.screen-up-to-md {
          margin: 1.875rem auto 0 auto;
          flex: 5;
          flex-basis: 20%;
        }

        @include mixins.screen-up-to-sm {
          margin: 1.875rem auto 0 auto;
          flex: 3;
          flex-basis: 33%;
        }
      }
    }
  }
}

@media all and (max-width: variables.$deviceWidthSM) {
  .page-footer {
    .footer-content {
      flex-direction: column;
    }

    .footer-links {
      justify-content: space-around;

      .left-side {
        margin-right: 0.625rem;
      }

      .footer-link {
        & > a {
          display: block;
          padding-bottom: 0.3125rem;
          margin-right: 0;
        }
      }
    }

    .footer-icons-container {
      width: 100%;
      padding-top: 0.9375rem;
      text-align: center;
    }

    .footer-copyright {
      margin-top: 0.625rem;
    }
  }
}
